import { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { brandLogo } from '../config/brandAssets';
import { MAIN_NAV, isActive } from '../data/nav';
import './header.css';

function Header() {
  const headerRef = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    const el = headerRef.current;
    if (!el) return;
    const setHeaderH = () => {
      document.documentElement.style.setProperty('--header-h', `${el.offsetHeight}px`);
    };
    setHeaderH();
    const observer = new ResizeObserver(setHeaderH);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <header ref={headerRef} className="site-header" role="banner">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <div className="header-inner wrap">
        <Link to="/" className="header-brand" aria-label="Al's-Ops LLC Home">
          <img
            src={brandLogo.src}
            srcSet={brandLogo.srcSet}
            sizes="32px"
            alt=""
            className="header-logo"
            width="32"
            height="32"
          />
          <span className="header-brand-name">Al's-Ops <span>LLC</span></span>
        </Link>

        <nav className="header-nav" aria-label="Main navigation">
          {MAIN_NAV.map(n => (
            <Link
              key={n.to}
              to={n.to}
              className={`nav-link${isActive(n, pathname) ? ' active' : ''}`}
              aria-current={pathname === n.to ? 'page' : undefined}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <a
          href="https://vigilhold.com"
          className="btn btn-outline header-cta"
          rel="noopener noreferrer"
          target="_blank"
          aria-label="Vigilhold — host agent for Linux, Windows, Docker, Kubernetes (opens vigilhold.com)"
        >
          Vigilhold <span aria-hidden="true">↗</span>
        </a>
      </div>
    </header>
  );
}

export default Header;
